import { Directive, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { SdControlValueAccessorDirective } from './sd-control-value-accessor.directive';

@Directive({ selector: '[wctSdModel]', standalone: true, providers: [SdModelDirective] })
export class SdModelDirective<T = object> extends SdControlValueAccessorDirective<T> implements OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input({ alias: 'wctSdModel', required: true }) public set value(value: any) {
    if (value === this._value) {
      return;
    }
    this.writeValue(value);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get value(): any {
    return this._value;
  }

  // eslint-disable-next-line @angular-eslint/no-output-rename, @typescript-eslint/no-explicit-any
  @Output('wctSdModelChange') public readonly update: Subject<any> = new EventEmitter();

  constructor() {
    super();
    this.registerOnChange(value => this.update.next(value));
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.update.complete();
  }
}
